export const fontSizeBase = 16;
export const fontSizeRate = 1;
export const fontSize = fontSizeBase * fontSizeRate;
export const breakMobile = 40 * fontSize;
export const breakTabletPortrait = 50 * fontSize;
export const breakTablet = 64 * fontSize;

export const EXCO_SCRIPT = `(function(d,s,id){var js,fjs=d.getElementsByTagName(s)[0];if(d.getElementById(id))return;js=d.createElement(s);js.id=id;js.src='https://embed.ex.co/sdk.js';fjs.parentNode.insertBefore(js,fjs);}(document,'script','exco-sdk'));`;
export const SITE_URL = process.env.GATSBY_SITE_URL;

export const APPLICATION_FORM_ID = 'application-form';
export const SEARCH_QUERY_PARAMETER_NAME = 'query';
